// vi越南
export default {
    CustomSelect: {
        '请选择': 'Chọn',
    },
    TopNav: {
        '创作者': 'Người sáng tạo',
        '游客': 'Khách',
        '请登录后体验完整功能': 'Vui lòng đăng nhập để sử dụng đầy đủ chức năng',
        '登录': 'Đăng nhập',
        '免费试用': 'Dùng thử miễn phí',
        '退出登录': 'Đăng xuất',
        '个人中心': 'Tài khoản của tôi',
        '我的视频': 'Video của tôi',
        '额度管理': 'Quản lý hạn mức',
        '首页': 'Trang chủ',
        'AI创作': 'Sáng tạo AI',
        '多参考': 'Đa tham chiếu',
        '文本视频': 'Văn bản thành video',
        '图片视频': 'Hình ảnh thành video',
        '文生图': 'Văn bản thành ảnh',
        '图生图': 'Ảnh thành ảnh',
        '会员中心': 'hội viên',
        '概览': 'Tổng quan',
        '我的创作': 'Sáng tác của tôi',
        '账单管理': 'Quản lý hóa đơn',
        '生成任务': 'Nhiệm vụ tạo',
        '价格': 'Giá cả',
        '新闻资讯': 'Tin tức',
        '确定要退出登录吗？': 'Bạn có chắc chắn muốn đăng xuất?',
        '提示': 'Gợi ý',
        '确定': 'Xác nhận',
        '取消': 'Hủy',
        '退出成功': 'Đăng xuất thành công',
        '视频展示': 'video trình diễn'
    },
    AiLayout: {
        'AI创作中心': 'Trung tâm sáng tạo AI',
        '视频生成': 'Tạo video',
        '图片生成': 'Tạo ảnh',
        '我的作品': 'Tác phẩm của tôi',
        '我的创作': 'Sáng tác của tôi',
        '今日剩余额度': 'Hạn mức còn lại hôm nay',
        '多参考': 'Đa tham chiếu',
        '文本视频': 'Văn bản thành video',
        '图片视频': 'Hình ảnh thành video',
        '文生图': 'Văn bản thành ảnh',
        '图生图': 'Ảnh thành ảnh',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Nền tảng tạo video AI thế hệ tiếp theo, biến ý tưởng thành hiện thực tức thì',
        '产品': 'Sản phẩm',
        'AI视频': 'Video AI',
        '价格方案': 'Gói giá',
        '新闻资讯': 'Tin tức',
        '支持': 'Hỗ trợ',
        '帮助中心': 'Trung tâm trợ giúp',
        'API文档': 'Tài liệu API',
        '常见问题': 'Câu hỏi thường gặp',
        '法律': 'Pháp lý',
        '服务条款': 'Điều khoản dịch vụ',
        '隐私政策': 'Chính sách bảo mật',
        '使用协议': 'Thỏa thuận sử dụng',
        '版权所有': 'Bảo lưu mọi quyền',
        '客服邮箱': 'Email hỗ trợ',
        '复制邮箱': 'Sao chép email',
        '开发中': 'Đang phát triển, hãy chờ đón!',
        '链接已复制到剪贴板': 'Đã sao chép liên kết vào clipboard',
    },
    MyLayout: {
        '创作者': 'Người sáng tạo',
        '退出登录': 'Đăng xuất',
        '概览': 'Tổng quan',
        '我的创作': 'Sáng tác của tôi',
        '会员中心': 'Trung tâm thành viên',
        '额度管理': 'Quản lý hạn mức',
        '账单管理': 'Quản lý hóa đơn',
        '生成任务': 'Nhiệm vụ tạo',
        '确定要退出登录吗？': 'Bạn có chắc chắn muốn đăng xuất?',
        '提示': 'Gợi ý',
        '确定': 'Xác nhận',
        '取消': 'Hủy',
        '退出成功': 'Đăng xuất thành công'
    },
    Image: {
        "文本生成图片": "Văn bản thành ảnh",
        "图片生成图片": "Ảnh thành ảnh",
        "用文字描述": "Mô tả bằng lời hình ảnh bạn mong muốn",
        "上传图片素材": "Tải lên tài liệu hình ảnh, hỗ trợ tạo nhiều ảnh",
        "图片描述": "Mô tả ảnh",
        "描述您想要的图片": "Mô tả chi tiết nội dung hình ảnh bạn muốn tạo, hỗ trợ tiếng Việt hoặc tiếng Anh...",
        "提示描述越详细效果越好": "Gợi ý: Mô tả càng chi tiết, kết quả tạo càng tốt",
        "图片素材": "Tài liệu hình ảnh",
        "预览图片": "Xem trước",
        "上传图片": "Tải ảnh lên",
        "支持格式JPGPNG": "Hỗ trợ định dạng JPG, PNG",
        "最多": "Tối đa",
        "张图片": "ảnh",
        "超过大小限制": "Vượt quá giới hạn 10MB",
        "不是图片文件": "Tệp hình ảnh không hợp lệ",
        "最多上传": "Tải lên tối đa",
        "请先上传图片": "Vui lòng tải lên tài liệu hình ảnh trước",
        "请选择要生成的图片": "Vui lòng chọn ảnh cần tạo",
        "生成结果": "Kết quả tạo",
        "重新生成成功": "Tạo lại thành công",
        "模型": "Mô hình AI",
        "请选择模型": "Vui lòng chọn mô hình tạo",
        "分辨率": "Độ phân giải đầu ra",
        "请选择分辨率": "Vui lòng chọn độ phân giải",
        "图片比例": "Tỷ lệ khung hình",
        "补充描述": "Mô tả bổ sung (tùy chọn)",
        "补充描述提示": "Tùy chọn: mô tả bất kỳ hiệu ứng hoặc phong cách bổ sung nào bạn muốn ảnh có",
        "开始绘制": "Bắt đầu vẽ",
        "开始生成": "Bắt đầu tạo",
        "生成中": "Đang tạo, vui lòng đợi...",
        "生成成功": "Thành công",
        "图片生成成功": "Tạo ảnh thành công!",
        "作品已保存到我的作品": "Tác phẩm đã được lưu vào 'Tác phẩm của tôi'",
        "继续创作": "Tiếp tục sáng tác",
        "查看作品": "Xem tác phẩm",
        "请输入图片描述": "Vui lòng nhập mô tả ảnh"
    },
    MyCreation: {
        '我的创作': 'Sáng tác của tôi',
        '查看和管理您的所有作品': 'Xem và quản lý tất cả tác phẩm của bạn',
        '预览': 'Xem trước',
        '下载': 'Tải xuống',
        '编辑': 'Chỉnh sửa',
        '分享': 'Chia sẻ',
        '删除': 'Xóa',
        '暂无作品': 'Chưa có tác phẩm',
        '去创作': 'Sáng tác',
        '确定删除': 'Xác nhận xóa',
        '确定要删除作品': 'Bạn có chắc chắn muốn xóa tác phẩm',
        '吗？': '?',
        '此操作不可恢复': 'Thao tác này không thể hoàn tác, vui lòng cẩn thận!',
        '取消': 'Hủy',
        '分享作品': 'Chia sẻ tác phẩm',
        '复制链接': 'Sao chép liên kết',
        '全部': 'Tất cả',
        '视频': 'Video',
        '图片': 'Hình ảnh',
        '正在下载:': 'Đang tải xuống: ',
        '链接已复制到剪贴板': 'Đã sao chép liên kết vào clipboard',
        '删除成功': 'Xóa thành công'
    },
    Video: {
        "文本生成视频": "Văn bản thành video",
        "图片生成视频": "Hình ảnh thành video",
        "智能视频生成": "Tạo video thông minh",
        "输入文字描述": "Nhập mô tả văn bản",
        "上传1-9张图片": "Tải lên 1-9 ảnh",
        "上传图片视频音频": "Tải lên ảnh/video/âm thanh",
        "视频描述": "Mô tả video",
        "描述您想要的视频场景": "Mô tả cảnh video bạn mong muốn",
        "提示": "Gợi ý",
        "图片素材": "Tài liệu hình ảnh",
        "最多上传": "Tải lên tối đa",
        "张": "ảnh",
        "预览": "Xem trước",
        "上传图片": "Tải ảnh lên",
        "支持格式": "Định dạng JPG, PNG, tối đa 10MB mỗi tệp, tối đa",
        "AI": "AI kết hợp thông minh và sẽ tạo ra hiệu ứng chuyển cảnh mượt mà",
        "动态描述": "Mô tả chuyển động",
        "描述您希望图片如何动起来": "Mô tả cách bạn muốn hình ảnh chuyển động",
        "个": "mục",
        "上传视频": "Tải video lên",
        "上传音频": "Tải âm thanh lên",
        "描述您希望视频呈现的效果": "Mô tả hiệu ứng video bạn mong muốn",
        "模型": "Mô hình",
        "请选择模型": "Vui lòng chọn mô hình",
        "分辨率": "Độ phân giải",
        "请选择分辨率": "Vui lòng chọn độ phân giải",
        "宽高比": "Tỷ lệ khung hình",
        "视频时长": "Thời lượng video",
        "生成音频": "Tạo âm thanh",
        "开启音效": "Bật hiệu ứng âm thanh",
        "静音模式": "Chế độ tắt tiếng",
        "音频提示": "Gợi ý: Âm thanh đã tải lên sẽ được sử dụng làm nhạc nền, nếu không tải âm thanh lên, AI sẽ tự động tạo nhạc",
        "开始生成": "Bắt đầu tạo",
        "积分": "Điểm",
        "生成中": "Đang tạo",
        "生成成功": "Thành công",
        "视频生成成功！": "Tạo video thành công!",
        "作品已保存到": "Tác phẩm đã được lưu vào 'Tác phẩm của tôi'",
        "继续创作": "Tiếp tục sáng tác",
        "查看作品": "Xem tác phẩm",
        "视频预览": "Xem trước video",
        "关闭": "Đóng",
        "下载视频": "Tải video xuống",
        "您的浏览器不支持视频播放": "Trình duyệt của bạn không hỗ trợ phát video",
        "生成进度": "Tiến độ tạo",
        "描述": "Mô tả",
        "时长": "Thời lượng",
        "秒": "giây",
        "视频素材": "Tài liệu video",
        "音频素材": "Tài liệu âm thanh",
        "双图融合模式": "Chế độ hợp nhất hai ảnh",
        "开始下载视频": "Bắt đầu tải video xuống",
        "请输入视频描述": "Vui lòng nhập mô tả video",
        "请至少上传一张图片": "Vui lòng tải lên ít nhất một ảnh",
        "请至少上传一张图片或一个视频": "Vui lòng tải lên ít nhất một ảnh hoặc một video",
        "最多只能上传": "Tải lên tối đa",
        "超过": "Vượt quá",
        "限制": "giới hạn",
        "不是图片文件": "Không phải tệp hình ảnh hợp lệ",
        "不是视频文件": "Không phải tệp video hợp lệ",
        "不是音频文件": "Không phải tệp âm thanh hợp lệ"
    },
    Forgot: {
        "找回密码": "Khôi phục mật khẩu",
        "请输入您的邮箱，我们将发送验证码": "Vui lòng nhập email của bạn, chúng tôi sẽ gửi mã xác nhận",
        "密码重置成功，请使用新密码登录": "Đặt lại mật khẩu thành công, vui lòng đăng nhập bằng mật khẩu mới",
        "密码重置成功": "Đặt lại mật khẩu thành công",
        "您的密码已成功重置，请使用新密码登录": "Mật khẩu của bạn đã được đặt lại thành công, vui lòng đăng nhập bằng mật khẩu mới",
        "立即登录": "Đăng nhập ngay",
        "邮箱": "Email",
        "请输入注册邮箱": "Vui lòng nhập email đã đăng ký",
        "发送验证码": "Gửi mã xác nhận",
        "请输入验证码": "Vui lòng nhập mã xác nhận",
        "验证码": "Mã xác nhận",
        "新密码": "Mật khẩu mới",
        "设置新密码": "Đặt mật khẩu mới",
        "确认新密码": "Xác nhận mật khẩu mới",
        "再次输入新密码": "Nhập lại mật khẩu mới",
        "重置密码": "Đặt lại mật khẩu",
        "返回登录": "Quay lại đăng nhập",
        "验证中": "Đang xác nhận",
        "重置中": "Đang đặt lại",
        "弱": "Yếu",
        "中": "Trung bình",
        "强": "Mạnh",
        "请输入邮箱地址": "Vui lòng nhập địa chỉ email",
        "请输入正确的邮箱格式": "Vui lòng nhập đúng định dạng email",
        "验证码应为6位数字": "Mã xác nhận phải gồm 6 chữ số",
        "请输入新密码": "Vui lòng nhập mật khẩu mới",
        "密码至少需要6位": "Mật khẩu phải có ít nhất 6 ký tự",
        "请再次输入新密码": "Vui lòng nhập lại mật khẩu mới",
        "两次输入的密码不一致": "Mật khẩu nhập không khớp",
        "验证码已发送": "Mã xác nhận đã được gửi"
    },
    Login: {
        "下一代AI视频生成平台": "Nền tảng tạo video AI thế hệ tiếp theo",
        "一键生成": "Tạo một chạm",
        "支持4K超高清输出": "Hỗ trợ đầu ra 4K siêu nét",
        "多种风格模板任选": "Chọn từ nhiều mẫu phong cách",
        "商用授权无忧使用": "Giấy phép thương mại, sử dụng thoải mái",
        "欢迎回来": "Chào mừng trở lại",
        "登录您的账号继续创作": "Đăng nhập để tiếp tục sáng tác",
        "邮箱": "Email",
        "请输入邮箱地址": "Vui lòng nhập địa chỉ email",
        "密码": "Mật khẩu",
        "请输入您的密码": "Vui lòng nhập mật khẩu của bạn",
        "记住我": "Ghi nhớ tôi",
        "忘记密码？": "Quên mật khẩu?",
        "登录": "Đăng nhập",
        "登录中": "Đang đăng nhập",
        "还没有账号？": "Chưa có tài khoản?",
        "立即注册": "Đăng ký ngay",
        "请输入正确的邮箱格式": "Vui lòng nhập đúng định dạng email",
        "请输入密码": "Vui lòng nhập mật khẩu",
        "密码至少需要6位": "Mật khẩu phải có ít nhất 6 ký tự",
        "密码不能超过20位": "Mật khẩu không được vượt quá 20 ký tự",
        "登录成功": "Đăng nhập thành công"
    },
    Register: {
        "创建账号": "Tạo tài khoản",
        "开始您的AI视频创作之旅": "Bắt đầu hành trình sáng tạo video AI của bạn",
        "姓名": "Họ tên",
        "请输入您的姓名": "Vui lòng nhập họ tên của bạn",
        "邮箱": "Email",
        "请输入邮箱地址": "Vui lòng nhập địa chỉ email",
        "获取验证码": "Lấy mã xác nhận",
        "验证码": "Mã xác nhận",
        "请输入验证码": "Vui lòng nhập mã xác nhận",
        "密码": "Mật khẩu",
        "设置密码": "Đặt mật khẩu",
        "确认密码": "Xác nhận mật khẩu",
        "再次输入密码": "Nhập lại mật khẩu",
        "我已阅读并同意": "Tôi đã đọc và đồng ý với",
        "服务条款": "Điều khoản dịch vụ",
        "和": "và",
        "隐私政策": "Chính sách bảo mật",
        "注册中": "Đang đăng ký",
        "已有账号？": "Đã có tài khoản?",
        "立即登录": "Đăng nhập ngay",
        "弱": "Yếu",
        "中": "Trung bình",
        "强": "Mạnh",
        "请输入姓名": "Vui lòng nhập họ tên",
        "姓名至少需要2个字符": "Họ tên phải có ít nhất 2 ký tự",
        "姓名不能超过20个字符": "Họ tên không được vượt quá 20 ký tự",
        "请输入正确的邮箱格式": "Vui lòng nhập đúng định dạng email",
        "验证码应为6位数字": "Mã xác nhận phải gồm 6 chữ số",
        "请输入密码": "Vui lòng nhập mật khẩu",
        "密码至少需要6位": "Mật khẩu phải có ít nhất 6 ký tự",
        "密码不能超过20位": "Mật khẩu không được vượt quá 20 ký tự",
        "请再次输入密码": "Vui lòng nhập lại mật khẩu",
        "两次输入的密码不一致": "Mật khẩu nhập không khớp",
        "验证码已发送": "Mã xác nhận đã được gửi",
        "注册成功": "Đăng ký thành công"
    },
    Faq: {
        '常见问题': 'Câu hỏi thường gặp',
        '您在使用过程中遇到的问题': 'Các vấn đề bạn gặp phải khi sử dụng, hãy tìm câu trả lời tại đây',
        '搜索您的问题': 'Tìm kiếm câu hỏi của bạn...',
        '没有找到相关的问题': 'Không tìm thấy câu hỏi liên quan',
        '查看全部问题': 'Xem tất cả câu hỏi',
        '没有找到您想要的答案？': 'Không tìm thấy câu trả lời bạn cần?',
        '我们的客服团队随时为您提供帮助': 'Đội ngũ hỗ trợ của chúng tôi sẵn sàng giúp đỡ bạn',
        '复制客服邮箱': 'Sao chép email hỗ trợ',
        '链接已复制到剪贴板': 'Đã sao chép liên kết vào clipboard'
    },
    Home: {
        '立即订阅': 'Đăng ký ngay',
        'AI视频生成新时代': 'Kỷ nguyên mới của tạo video AI',
        '用文字创造': 'Sáng tạo bằng ngôn từ',
        '无限视频': 'Video không giới hạn',
        '让每个人都能成为视频创作者': 'Cho phép mọi người trở thành người sáng tạo video. Chỉ cần nhập mô tả văn bản để có được video AI chất lượng cao, độc đáo.',
        '免费开始': 'Bắt đầu miễn phí',
        '观看演示': 'Xem trình diễn',
        'AI生成': 'Tạo bằng AI',
        'AI视频': 'Video AI',
        '三步轻松生成专业视频': 'Ba bước đơn giản để tạo video chuyên nghiệp',
        '输入提示词': 'Nhập gợi ý',
        '用文字描述您想要的视频内容': 'Mô tả bằng lời nội dung video bạn mong muốn, càng chi tiết càng tốt',
        '智能生成': 'Tạo thông minh',
        'AI模型自动理解并创作': 'Mô hình AI tự động hiểu và sáng tác, quá trình render hoàn tất trong vài phút',
        '下载作品': 'Tải xuống tác phẩm',
        '高清视频生成完成': 'Tạo video HD hoàn tất, sẵn sàng tải xuống và sử dụng ngay',
        'AI视频生成': 'Tạo video AI',
        '精彩视频': 'Nhập mô tả văn bản, AI sẽ tạo ra video tuyệt vời cho bạn',
        '描述您想要的视频场景': 'Mô tả cảnh video bạn mong muốn, ví dụ: Một chú mèo đang chơi dưới gốc cây anh đào, ánh nắng xuyên qua những cánh hoa...',
        '生成中': 'Đang tạo...',
        '生成视频': 'Tạo video',
        'AI图片': 'Ảnh AI',
        '精美图片': 'Nhập mô tả văn bản, AI sẽ tạo ra hình ảnh tuyệt vời cho bạn',
        '描述您想要的图片场景': 'Mô tả cảnh hình ảnh bạn mong muốn, ví dụ: Đường chân trời thành phố tương lai, đèn neon lấp lánh, phong cách cyberpunk...',
        '生成图片': 'Tạo ảnh',
        '强大功能': 'Tính năng mạnh mẽ',
        '让视频创作变得简单有趣': 'Làm cho việc sáng tạo video trở nên đơn giản và thú vị',
        '案例展示': 'Ví dụ',
        '来看看用户使用': 'Xem những tác phẩm tuyệt vời được tạo ra bởi',
        '创作的精彩作品': 'người dùng',
        '新闻资讯': 'Tin tức',
        '了解': 'Khám phá',
        '的最新动态和产品更新': 'tin tức mới nhất và cập nhật sản phẩm',
        '查看更多': 'Xem thêm',
        '热门': 'Phổ biến',
        '最新': 'Mới nhất',
        '阅读更多': 'Đọc thêm',
        '选择适合您的方案': 'Chọn gói phù hợp với bạn',
        '灵活的定价': 'Giá linh hoạt đáp ứng nhu cầu khác nhau',
        '视频预览': 'Xem trước video',
        '生成成功': 'Thành công',
        '作品已保存到': 'Tác phẩm đã được lưu vào "Sáng tác của tôi"',
        '继续创作': 'Tiếp tục sáng tác',
        '查看作品': 'Xem tác phẩm',
        '请输入视频描述': 'Vui lòng nhập mô tả video',
        '视频生成成功！': 'Tạo video thành công!',
        '请输入图片描述': 'Vui lòng nhập mô tả ảnh',
        '图片生成成功！': 'Tạo ảnh thành công!',
    },
    News: {
        '新闻资讯': 'Tin tức',
        '了解': 'Khám phá',
        '的最新动态和产品更新': 'tin tức mới nhất và cập nhật sản phẩm',
        '精选': 'Chọn lọc',
        '阅读': 'Đọc',
        '点赞': 'Thích',
        '热门': 'Phổ biến',
        '最新': 'Mới nhất',
        '阅读更多': 'Đọc thêm',
        '加载中': 'Đang tải...',
        '暂无新闻': 'Không có tin tức',
        '清除筛选': 'Xóa bộ lọc',
        '加载新闻失败': 'Tải tin tức thất bại, vui lòng thử lại sau',
    },
    Price: {
        '选择适合您的方案': 'Chọn gói phù hợp với bạn',
        '灵活的定价': 'Giá linh hoạt đáp ứng nhu cầu khác nhau',
        '包月': 'Theo tháng',
        '包年': 'Theo năm',
        '购买积分': 'Mua điểm',
        '只需要几个视频': 'Chỉ cần vài video? Không cần đăng ký, mua trực tiếp gói điểm',
        '产品大全': 'Danh mục sản phẩm',
        '了解': 'Tìm hiểu',
        '全系列产品的详细信息和支付方式': 'thông tin chi tiết và phương thức thanh toán cho toàn bộ dòng sản phẩm'
    },
    Billing: {
        '账单管理': 'Quản lý hóa đơn',
        '账户余额': 'Số dư tài khoản',
        '本月支出': 'Chi tiêu tháng này',
        '订单数量': 'Số lượng đơn hàng',
        '账单列表': 'Danh sách hóa đơn',
        '请选择类型': 'Vui lòng chọn loại',
        '请选择时间范围': 'Vui lòng chọn khoảng thời gian',
        '订单号': 'Mã đơn hàng',
        '类型': 'Loại',
        '金额': 'Số tiền',
        '状态': 'Trạng thái',
        '时间': 'Thời gian',
        '操作': 'Thao tác',
        '查看详情': 'Xem chi tiết',
        '下载发票': 'Tải hóa đơn',
        '暂无作品': 'Chưa có tác phẩm',
        '去创作': 'Sáng tác',
        '支付方式': 'Phương thức thanh toán',
        '添加支付方式': 'Thêm phương thức',
        '默认': 'Mặc định',
        '设为默认': 'Đặt làm mặc định',
        '编辑': 'Chỉnh sửa',
        '删除': 'Xóa',
        '账单详情': 'Chi tiết hóa đơn',
        '交易流水号': 'Mã giao dịch',
        '关闭': 'Đóng',
        '账号': 'Số tài khoản/thẻ',
        '请输入账号或卡号': 'Vui lòng nhập số tài khoản hoặc thẻ',
        '姓名': 'Họ tên',
        '请输入持卡人姓名': 'Vui lòng nhập tên chủ thẻ',
        '有效期': 'Ngày hết hạn',
        '请输入CVV码': 'Vui lòng nhập mã CVV',
        '取消': 'Hủy',
        '确认添加': 'Xác nhận thêm',
        '确认修改': 'Xác nhận sửa',
        '确认删除': 'Xác nhận xóa',
        '编辑支付方式': 'Chỉnh sửa phương thức thanh toán',
        '确定要删除支付方式': 'Bạn có chắc chắn muốn xóa phương thức thanh toán này?',
        '删除后不可恢复': 'Thao tác xóa không thể hoàn tác, vui lòng cẩn thận!',
        '请输入账号': 'Vui lòng nhập số tài khoản/thẻ',
        '添加成功': 'Thêm thành công',
        '修改成功': 'Sửa thành công',
        '已设为默认支付方式': 'Đã đặt làm phương thức thanh toán mặc định',
        '删除成功': 'Xóa thành công',
    },
    Credit: {
        '额度管理': 'Quản lý hạn mức',
        '当前可用额度': 'Hạn mức khả dụng hiện tại',
        '升级会员': 'Nâng cấp thành viên',
        '本月已用': 'Đã sử dụng trong tháng',
        '视频生成': 'Tạo video',
        'AI图片': 'Ảnh AI',
        '其他': 'Khác',
        '购买额度包': 'Mua gói hạn mức',
        '最受欢迎': 'Phổ biến nhất',
        '额度': 'Hạn mức',
        '立即购买': 'Mua ngay',
        '使用记录': 'Lịch sử sử dụng',
        '操作': 'Thao tác',
        '类型': 'Loại',
        '额度变动': 'Biến động hạn mức',
        '时间': 'Thời gian',
        '购买': 'Mua',
        '确认购买': 'Xác nhận mua',
        '金额': 'Số tiền: ',
        '获得': 'Nhận được',
        '取消': 'Hủy',
        '今天': 'Hôm nay',
        '昨天': 'Hôm qua',
    },
    Dashboard: {
        '欢迎回来': 'Chào mừng trở lại,',
        '创建新视频': 'Tạo video mới',
        '本月生成次数': 'Số lần tạo trong tháng',
        '剩余额度': 'Hạn mức còn lại',
        '总视频数': 'Tổng số video',
        '会员状态': 'Trạng thái thành viên',
        '最近生成': 'Tạo gần đây',
        '查看全部': 'Xem tất cả',
        '视频预览': 'Xem trước video',
        '视频生成中': 'Video đang được tạo, vui lòng đợi để xem trước',
    },
    Membership: {
        '会员中心': 'Trung tâm thành viên',
        '当前方案': 'Gói hiện tại',
        'Pro 会员': 'Thành viên Pro',
        '专业创作者首选': 'Lựa chọn hàng đầu cho người sáng tạo chuyên nghiệp',
        '月': 'tháng',
        '会员有效期': 'Thời hạn thành viên',
        '剩余天数': 'Số ngày còn lại',
        '续费会员': 'Gia hạn',
        '取消订阅': 'Hủy đăng ký',
        '本月使用情况': 'Tình trạng sử dụng tháng này',
        '视频生成': 'Tạo video',
        '次': 'lần',
        '额度使用': 'Sử dụng hạn mức',
        '快速生成': 'Tạo nhanh',
        '升级方案': 'Nâng cấp gói',
        '联系销售': 'Liên hệ bộ phận kinh doanh',
        '会员权益': 'Quyền lợi thành viên',
        '续费后将延长会员有效期30天': 'Gia hạn sẽ kéo dài thời hạn thành viên thêm 30 ngày',
        '取消': 'Hủy',
        '确认续费': 'Xác nhận gia hạn',
        '取消后您将失去所有会员权益': 'Sau khi hủy, bạn sẽ mất tất cả quyền lợi thành viên, hạn mức còn lại sẽ được giữ nguyên',
        '再想想': 'Suy nghĩ lại',
        '确认取消': 'Xác nhận hủy',
        '姓名': 'Họ tên',
        '请输入您的姓名': 'Vui lòng nhập họ tên của bạn',
        '请输入姓名': 'Vui lòng nhập họ tên',
        '公司': 'Công ty',
        '请输入公司名称': 'Vui lòng nhập tên công ty',
        '邮箱': 'Email',
        '请输入邮箱地址': 'Vui lòng nhập địa chỉ email',
        '请输入邮箱': 'Vui lòng nhập email',
        '请输入正确的邮箱格式': 'Vui lòng nhập đúng định dạng email',
        '需求': 'Nhu cầu',
        '请描述您的需求': 'Vui lòng mô tả nhu cầu của bạn',
        '提交': 'Gửi',
        '请填写需求': 'Vui lòng mô tả nhu cầu',
        '续费成功': 'Gia hạn thành công! Thời hạn thành viên đã được kéo dài',
        '已取消订阅': 'Đã hủy đăng ký, thành viên sẽ hết hạn khi kết thúc thời hạn',
        '提交成功': 'Gửi thành công, chúng tôi sẽ liên hệ với bạn sớm nhất!',
    },
    Task: {
        '生成任务': 'Nhiệm vụ tạo',
        '新建任务': 'Nhiệm vụ mới',
        '进行中': 'Đang thực hiện',
        '已完成': 'Đã hoàn thành',
        '失败': 'Thất bại',
        '队列中': 'Trong hàng đợi',
        '活跃任务': 'Nhiệm vụ đang hoạt động',
        '刷新': 'Làm mới',
        '暂无活跃任务': 'Không có nhiệm vụ đang hoạt động',
        '预计剩余': 'Thời gian còn lại dự kiến',
        '暂停': 'Tạm dừng',
        '继续': 'Tiếp tục',
        '取消': 'Hủy',
        '最近完成': 'Hoàn thành gần đây',
        '查看全部': 'Xem tất cả',
        '暂无完成的任务': 'Không có nhiệm vụ đã hoàn thành',
        '播放': 'Phát',
        '下载': 'Tải xuống',
        "分享": "Chia sẻ",
        "确认取消": "Xác nhận",
        "确定要取消任务吗": "Hủy nhiệm vụ?",
        "已消耗的额度将无法退还": "Credit đã dùng không hoàn lại",
        "返回": "Quay lại",
        "分享作品": "Chia sẻ",
        "复制链接": "Sao chép link",
        "任务列表已刷新": "Đã làm mới",
        "已暂停": "Đã tạm dừng",
        "生成中": "Đang tạo",
        "已恢复": "Đã tiếp tục",
        "任务已取消": "Đã hủy",
        "链接已复制到剪贴板": "Đã sao chép link",
    },
    VideoShow: {
        '示例': 'Ví dụ',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Bộ sưu tập các clip được tuyển chọn cẩn thận từ thư viện demo của chúng tôi. Nhấp vào bất kỳ thẻ nào để bắt đầu tạo nội dung có phong cách tương tự.',
        '全部': 'Tất cả',
        '电影感': 'Điện ảnh',
        '角色': 'Nhân vật',
        '产品': 'Sản phẩm',
        '自然': 'Thiên nhiên',
        '趣味': 'Vui nhộn',
        '加载中': 'Đang tải',
        '暂无展示': 'Không có bản demo',
        '视频预览': 'Xem trước video',
    },
    Request: {
        '加载中': 'Đang tải...',
        '您已退出登录': 'Bạn đã đăng xuất, có thể đăng nhập lại',
        '确认退出': 'Xác nhận đăng xuất',
        '重新登录': 'Đăng nhập lại',
        '错误': 'Lỗi',
        '网络错误': 'Lỗi mạng',
        '下载中': 'Đang tải xuống...'
    },
    Other: {
        '剩余额度': 'Hạn mức còn lại',
        '去登录': 'Đăng nhập',
        '请登录后查看': 'Vui lòng đăng nhập để xem',
        '任务': 'Nhiệm vụ',
        '可在「生成任务」中查看详情': ', chi tiết có thể xem trong "Nhiệm vụ tạo"',
        '查看详情': 'Xem chi tiết',
        '排队中': 'Đang xếp hàng',
        '运行中': 'Đang chạy',
        '取消': 'Hủy',
        '成功': 'Thành công',
        '失败': 'Thất bại',
        '超时': 'Hết thời gian',
        '最后更新': 'Cập nhật lần cuối:',
        '视频生成': 'Tạo video',
        '活跃用户': 'Người dùng hoạt động',
        '用户评分': 'Đánh giá của người dùng',
        '万': 'nghìn',
        '快速生成': 'Tạo nhanh',
        '先进的AI模型': 'Mô hình AI tiên tiến, tạo video chất lượng cao trong vài phút',
        '多种风格': 'Nhiều phong cách',
        '多种风格任您选择': 'Hiện thực, anime, nghệ thuật và nhiều phong cách khác cho bạn lựa chọn',
        '高清输出': 'Đầu ra HD',
        '支持4K超高清视频输出': 'Hỗ trợ xuất video 4K siêu nét, chi tiết hiển thị rõ ràng',
        '商用授权': 'Giấy phép thương mại',
        '生成的视频可用于商业用途': 'Video tạo ra có thể được sử dụng cho mục đích thương mại, không lo ngại về bản quyền',
        '原价': 'Giá gốc',
        '积分价格说明': 'Giải thích giá tích điểm',
        '系列': 'Dòng sản phẩm',
        '模型': 'Mô hình',
        '分辨率': 'Độ phân giải',
        '积分': 'Điểm tích lũy',
        '秒': 'giây',
        '秒示例': 'giây (ví dụ)',
        '图片模型': 'Mô hình ảnh',
        '图片为': 'Ảnh là',
        '系列产品': 'Sản phẩm của dòng, hiện hỗ trợ',
        '支持使用任意机型查看完整体验': ', hỗ trợ sử dụng mọi loại thiết bị để trải nghiệm đầy đủ.',
        '计费方式': 'Phương thức thanh toán',
        '张': 'ảnh',
        '按生成张数计费': 'Thanh toán theo số lượng ảnh được tạo',
        '普通用户': 'Người dùng thông thường',
        '无记录': 'Không có bản ghi',
        '总支出': 'Tổng chi tiêu',
        '月总使用': 'Tổng sử dụng hàng tháng',
        '月视频使用': 'Sử dụng video hàng tháng',
        '月图片使用': 'Sử dụng ảnh hàng tháng',
        '生成成功': 'Tạo thành công',
        '视频总生成': 'Tổng video đã tạo',
        '图片总生成': 'Tổng ảnh đã tạo',
        '生成中': 'Đang tạo, vui lòng đợi 1-3 phút',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Một bộ sưu tập các clip được tuyển chọn cẩn thận từ thư viện bản trình diễn của chúng tôi.',
        '最近7天': '7 ngày qua',
        '最近30天': '30 ngày qua',
        '本月': 'Tháng này',
        '上月': 'Tháng trước',
        '选择支付方式': 'Chọn phương thức thanh toán',
        '确认支付': 'Xác nhận thanh toán'
    }
}
